import React from "react";
import {
  Box,
  Typography,
  Divider,
  Grid,
  useTheme,
  makeStyles,
  Button
} from "@material-ui/core";
import KenInputField from "../../global_components/KenInputField";
import KenButton from "../../global_components/KenButton";
import context from "../../Utils/context";
import { sendBulkSMS, getSmsTemplates, gradeWiseSms } from "../../Utils/apiServices";
import KenCard from "../../global_components/KenCard";
import SmsAndMailSelection from "../../Components/SmsAndMailSelection/index"
import { useTranslation } from 'react-i18next';
import CSVReader from 'react-csv-reader'
import KenSnackbar from '../../Components/KenSnackbar/index';
import KenLoader from '../../Components/KenLoader/index';
import KenSelect from '../../global_components/KenSelect/index';
import { Router, useHistory } from 'react-router-dom';
import routes from '../../Utils/routes.json';

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    height: "100%",
  },
  note: {
    position: "absolute",
    bottom: 8,
    width: "100%",
  },
  fileUpload: {
    float: "right"
  },
  reactCsvInput: {
    opacity: "0",
    position: "absolute"

  },
  btnUpload: {
    position: "relative",
    background: "rgba(0,0,0,0.15)",
    width: "200px"
  },
  cancelButton: {
    marginRight: "10px"
  }
}));

export default function Sms() {
  const { t } = useTranslation();
  const history = useHistory();

  const classes = useStyles();
  const theme = useTheme();

  const [message, setMessage] = React.useState(null);
  const [selectedMessage, setSelectedMessage] = React.useState();

  const [to, setTo] = React.useState('');
  const [selectedType, setSelectedType] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [senderId, setSenderId] = React.useState(null);

  const [templateList, setTemplateLits] = React.useState('');

  const [gradeWisePayload, setGradeWisePayload] = React.useState(null);
  const [resetFrom, setRestForm] = React.useState(true);
  const [typeValue, setTypeValues] = React.useState();



  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const senderList = [
    { label: "NCFCECVR", value: "NCFCECVR" },
    { label: "NCFEJB", value: "NCFEJB" },
    { label: "VKGI", value: "VKGI" },
    { label: "VKS", value: "VKS" }

  ]
  const getTemplates = async () => {
    try {
      setLoading(true);
      const smsTemplate = await getSmsTemplates();
      const templateListMap = smsTemplate.map((v) => {
        return {label: v.Template, value: v.Template}
      });
      setTemplateLits(templateListMap);
      setLoading(false);
    } catch (error) {
      setTemplateLits([]);
      setLoading(false);
    }
   


  }


  const sendGradeWiseSMS = async () => {
    try {
      const messageBody = {
        ...gradeWisePayload,
        sectionId: '',
        message: message,
        senderName: senderId
      }
      setRestForm(false);
      if(messageBody.message != null && messageBody.senderName != null && gradeWisePayload!= null){
        setLoading(true);
        const getDetails = await gradeWiseSms({messageBody});
          handleSnackbarOpen('success', t("messages:sms_send_successfully"))
          await setMessage(null)
          await setSelectedMessage(null)
          history.push(`/${routes.sendSMS}`)
          setRestForm(true);
          setTypeValues('')

      } else {
        setRestForm(true);
        setTypeValues('')
        handleSnackbarOpen('error', t("messages:error_message_for_sms"))
      }
    } catch (error) {
      setLoading(false);
      setRestForm(true);
      setTypeValues('');
      handleSnackbarOpen('error', t("messages:internal_server_error"))
    }
    
  };

  const cancelHandler = async () => {
    await setMessage(null);
    await setSelectedMessage(null);
    setTypeValues('');
    await setTemplateLits('');
    await setTo('');
    setRestForm(true);

  }


  



  const handleSend = async () => {

    try {
      const messageBody = {
        numbers: to,
        message: message,
        senderName: senderId
      }
      if(messageBody.numbers != "" && messageBody.message != null, messageBody.senderName != null){
        setLoading(true);
        const getDetails = await sendBulkSMS({messageBody});
          handleSnackbarOpen('success', t("messages:sms_send_successfully"))
          await setTo('')
          await setMessage(null)
          await setSelectedMessage(null)
          history.push(`/${routes.sendSMS}`)
      } else {
        handleSnackbarOpen('error', t("messages:error_message_for_sms"))
      }
    } catch (error) {
      setLoading(false)
      handleSnackbarOpen('error', error.Message)
    }
    
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };

  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const handleSelectType = async (value) => {
    await setSelectedType(value)
    console.log(value)
  }
  const handleForce = async (data, fileInfo) => {
    console.log("data :::: ", data)

    const numbers = [];
    data.forEach(element => {
      numbers.push(element.number);
    });
    await setTo(numbers.toString());
  }
  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
  };

  const handleGradeWiseDetails = (payload) => {
    setGradeWisePayload(payload);
  }

  
  React.useEffect(() => {
    getTemplates();

  }, [selectedType]);

  const changeTypes = (e) => {
    console.log(e.target.value);
    if (e.target.value === 'institute') {
        setRestForm(true);
    }
    setTypeValues(e.target.value);
    handleSelectType(e.target.value)

}
let types = [
  {
    label: 'Please select type',
    value: '',
  },
  
  {
      label: 'Institute',
      value: 'institute',
  },
  {
      label: 'Custom',
      value: 'custom',
  },
];


  return (
    <KenCard>
      <Box className={classes.root}>
        <Typography component="div">
          <Box fontSize={32} fontWeight="fontWeightBold">
            {t('labels:send_Sms')}
          </Box>
        </Typography>
        <Divider />
        <Box mt={2} mb={2}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4} md={4}>
                        <KenSelect
                            options={types}
                            value={typeValue}
                            onChange={changeTypes}
                            label={t('labels:select_type')}
                            required
                        />
                    </Grid>
                </Grid>
            </Box>

        { resetFrom && (typeValue === 'institute') && <SmsAndMailSelection type={1} typeValue={typeValue} handleSelectType={handleSelectType} handleGradeWiseDetails={handleGradeWiseDetails} />}

        <Box mt={2} mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4}>
              <KenSelect
                options={senderList}
                defaultValue={senderId?.value}
                value={senderId?.value}
                onChange={(e) => setSenderId(e.target.value)}
                label={t('labels:select_sender')}
                required
              />
            </Grid>
          </Grid>
        </Box>

        {selectedType === 'custom' && <Grid className={classes.fileUpload}>
          <Button
            cssClass={classes.btnUpload}>
            <CSVReader
              cssClass={classes.reactCsvInput}
              onFileLoaded={handleForce}
              parserOptions={papaparseOptions}
            />{t("labels:upload_file")}
          </Button>
        </Grid>}
        { selectedType !== 'institute' &&  <Grid
          container
          spacing={1}
          mt={8}
          style={{ marginTop: 16, marginBottom: 16 }}
        >
          <Grid item xs={12} sm={6} md={12}>
            <KenInputField
              label="To"
              required
              name="to"
              onChange={(e) => setTo(e.target.value)}
              value={to}
            />
          </Grid>
        </Grid>}
       {(to != '' || selectedType === 'institute') && templateList != '' && <Box>
          <KenSelect
            options={templateList}
            onChange={ async (e) => {
              const value = e.target.value;
              await setMessage('')
              setSelectedMessage(e.target.value);
              const message = value;
              setMessage(message)
            }
            }
            value={selectedMessage?.value}
            defaultValue={selectedMessage?.value}
            label={t('labels:select_message_template')}
            required
          />
         
        </Box>}
        <br></br>
        { message != null && <Box>
          <KenInputField
            multiline={true}
            label="Message"
            required
            name="message"
            onChange={(e) => setMessage(e.target.value)}
            value={message}
          />
        </Box>}
        <Box display="flex" justifyContent="flex-end" mt={1} mb={1}>
        <KenButton label={t('labels:cancel')} variant="secondary" onClick={cancelHandler} className={classes.cancelButton} />

          { (selectedType === 'custom' || selectedType === 'predefined') && <KenButton label={t('labels:send_Sms')} variant="primary" onClick={handleSend} />}
          { selectedType === 'institute' && <KenButton label={t('labels:send_Sms')} variant="primary" onClick={sendGradeWiseSMS} />}

        </Box>

      </Box>
      {loading && <KenLoader />}


      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />


    </KenCard>
  );
}
